// extracted by mini-css-extract-plugin
export var brand = "_44-9";
export var compact = "_44-6";
export var extraSmall = "_44-7";
export var icon = "_44-0";
export var large = "_44-4";
export var light = "_44-1";
export var medium = "_44-5";
export var outline = "_44-b";
export var primaryDark = "_44-a";
export var primaryLight = "_44-8";
export var primaryModern = "_44-c";
export var success = "_44-2";
export var successSolid = "_44-3";